module.exports = __webpack_public_path__ + "media/images/icons/outlined/schedule-870a27d5b3448c96917f1e74fbfe24fd.svg";